import { render, staticRenderFns } from "./ReviewOrderDetail.vue?vue&type=template&id=0e6ca550"
import script from "./ReviewOrderDetail.vue?vue&type=script&lang=js"
export * from "./ReviewOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./ReviewOrderDetail.vue?vue&type=style&index=0&id=0e6ca550&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports